import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Menu } from "../../helpers/datas";

export interface GlobalState {
  menu: (Menu | undefined)[];
  offline: boolean;
}

const initialState: GlobalState = {
  menu: [],
  offline: false,
};

export const GlobalSlice = createSlice({
  name: "@@app/global",
  initialState: initialState,
  reducers: {
    setMenuResponsive: (
      state: GlobalState,
      action: PayloadAction<(Menu | undefined)[]>
    ) => {
      state.menu = action.payload;
    },
    setOffline: (state: GlobalState, action: PayloadAction<boolean>) => {
      state.offline = action.payload;
    },
  },
});

export const { setMenuResponsive, setOffline } = GlobalSlice.actions;
